import { Facebook, Instagram, Mail } from 'lucide-react';
import { clubInfo } from '@/data/chkz';
import { useSiteText } from '@/lib/SiteTextContext';
import { useInView } from '@hooks/useScroll';

export function Footer() {
  const { t } = useSiteText();
  const { ref, isInView } = useInView();
  return (
    <footer className="bg-ocean-blue-dark text-white">
      {/* Final CTA */}
      <div className="py-24 md:py-32 border-b border-white/10">
        <div
          ref={ref}
          className={`container mx-auto px-6 md:px-12 lg:px-24 text-center transition-all duration-700 ease-sail ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-sm tracking-[0.3em] uppercase text-accent-gold mb-6">
            {clubInfo.name}
          </p>
                    <h2 className="font-display text-5xl md:text-7xl font-bold text-balance mb-8 text-wave">
            {t('footer.title')}
            <span className="block text-accent-gold">{t('footer.subtitle')}</span>
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10">
            <a
              href={clubInfo.facebookUrl}
              target="_blank"
              rel="noreferrer"
              className="link-underline flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300"
            >
              <Facebook size={20} className="text-accent-gold" /> Facebook
            </a>
            <a
              href={clubInfo.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="link-underline flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300"
            >
              <Instagram size={20} className="text-accent-gold" /> Instagram
            </a>
            <a
              href={'mailto:' + clubInfo.email}
              className="link-underline flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-300"
            >
              <Mail size={20} className="text-accent-gold" /> {clubInfo.email}
            </a>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="py-12">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="font-display text-xl font-bold mb-3 text-accent-gold">ChKŻ LOK</h3>
              <p className="text-sm text-misty-blue/70">
                Chodzieski Klub Żeglarski LOK
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-3 text-white">Kontakt</h4>
              <ul className="text-sm text-misty-blue/70 space-y-2">
                <li className="flex items-center gap-2">
                  <Mail size={14} /> {clubInfo.email}
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 text-center text-xs text-misty-blue/60">
                        © {new Date().getFullYear()} {clubInfo.name}. {t('footer.rights')}
          </div>
        </div>
      </div>
    </footer>
  );
}
